import queryString from "query-string";

export const convertQueryStringToObject = (str) => {

    return queryString.parse(str);

}